import { Component, Input } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { UIMessageReferenceProgress } from '../../../../types/types';

@Component({
    selector: 'app-ref-progress',
    templateUrl: './ref-progress.component.html',
    styleUrls: ['./ref-progress.component.scss'],
    standalone: true,
    imports: [MatProgressSpinner]
})
export class RefProgressComponent {
  @Input() progress: UIMessageReferenceProgress | undefined;

  get isLoading(): boolean {
    if (!this.progress) {
      return false;
    }
    return this.progress.status === 'initializing' || this.progress.status === 'processing';
  }

  get shouldShow(): boolean {
    if (!this.progress) {
      return false;
    }
    // Only show during active processing, hide when completed or error
    return this.progress.status === 'initializing' || this.progress.status === 'processing';
  }

  get statusMessage(): string {
    if (!this.progress) {
      return 'Verifying sources and generating citations…';
    }

    switch (this.progress.status) {
      case 'initializing':
        return 'Preparing to verify sources…';
      case 'processing':
        return 'Verifying sources and generating citations…';
      case 'completed':
        return 'References generated successfully';
      case 'error':
        return (
          this.progress.error || 'No knowledge base or embeddings available for this conversation'
        );
      default:
        return 'Verifying sources and generating citations…';
    }
  }

  /** e.g. "Section 3 of 10" when total > 1 */
  get progressLabel(): string | null {
    if (!this.progress || this.progress.total <= 1) {
      return null;
    }
    const processed = this.progress.processed ?? 0;
    const total = this.progress.total ?? 0;
    return `Section ${Math.min(processed, total)} of ${total}`;
  }

  /** 0–100 for progress bar when total > 0 */
  get progressPercent(): number {
    if (!this.progress || this.progress.total <= 0) {
      return 0;
    }
    const processed = this.progress.processed ?? 0;
    const total = this.progress.total ?? 0;
    return Math.min(100, Math.round((processed / total) * 100));
  }

  get showProgressBar(): boolean {
    if (!this.progress) return false;
    const status = this.progress.status;
    const total = this.progress.total ?? 0;
    return (
      (status === 'initializing' || status === 'processing') &&
      total > 1
    );
  }
}
